// PAGE ENDPOINTS
export const HOME_URL = '/';
export const ABOUT_URL = '/about'; 
export const RESOURCES_URL = '/resources';

// LINKS
export const PATIENT_PORTAL_URL = 'https://phr2.charmtracker.com/login.sas?serviceurl=%2Fphr%2Fprofile.do%3FACTION%3DSIGNOUT_PATIENT';
export const FULLSCRIPT_URL = 'https://support.fullscript.com/hc/en-us/articles/360035290692-Fullscript-buttons-for-your-website#:~:text=While%20editing%20your%20site%2C%20click,Add%20your%20code%20here%20field';